
































import { Component, Vue } from 'vue-property-decorator';
import TrafficLight from './TrafficLight.vue';
import { EverydayTrafficLight as EverydayTrafficLightModel } from '../../models/EverydayTrafficLight';

@Component({
    components: {
        TrafficLight
    }
})
export default class EverydayTrafficLight extends Vue {
    private trafficLights: EverydayTrafficLightModel[] = [];
    private isOpen: boolean = true;
    private title: string = 'Kapacitet stommar';

    constructor() {
        super();
    }

    mounted() {
        const dataTrafficLights = this.$attrs['data-traffic-lights'] as string;
        const title = this.$attrs['data-title'] as string;
        if (dataTrafficLights) {
            try {
                this.trafficLights = JSON.parse(dataTrafficLights);
                this.title = title;
            } catch (error) {
                console.error('Failed to parse traffic lights:', error);
            }
        }
    }

    private toggleMenu() {
        this.isOpen = !this.isOpen;
    }
}
